import okiFinancialForm from './oki-financial-form/oki-financial-form.vue';
import { mapState, mapActions } from 'vuex';
import store from '../../../common/js/vuex/oki-store';
import { ROUTE_NAMES, DEBUG, HEADER_HEIGHT } from '../constants/oki-constants';
import offset from 'document-offset';
const SCROLL_TO_REFS = ['financial-data-title'];
const TA_CODES = {
	OKI: {
		nextButtonSave: 'OKI_KARTYA_ES_SZAMLA_ADATOK_TOVABB',
		progressBarNavigation: 'OKI_KARTYA_SZAMLA_ADATOK_SZERKESZTEM'
	},
	SOKI: {
		nextButtonSave: 'SOKI_KARTYA_ES_SZAMLA_ADATOK_TOVABB',
		progressBarNavigation: 'SOKI_KARTYA_SZAMLA_ADATOK_SZERKESZTEM'
	}
};
export default {
	data() {
		return {
			postInProgress: false,
			saveFromProgressBar: false
		};
	},
	computed: {
		...mapState({
			schools: (state) => state.financial.schools,
			financialData: (state) => state.financial.financialData,
			phoneNumber: (state) => state.personal.personalData.mobilePhoneNumber,
			hasClaimCode: (state) => state.personal.personalData.hasClaimCode
		}),
		...mapState(['usageScopes', 'cardData', 'soki', 'swImgPath', 'isDevizaCard']),
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	components: {
		okiFinancialForm
	},
	methods: {
		postData(data) {
			this.postFinancialForm(data).then(() => {
				if (!this.saveFromProgressBar) {
					this.$router.push(this.soki ? ROUTE_NAMES.KARTYAKEP : ROUTE_NAMES.OSSZEGZES);
				}
				this.saveFromProgressBar = false;
			});
		},
		saveFinancialData(formData) {
			this.postInProgress = true;
			let data = {};
			let okiSoki = this.soki ? 'SOKI' : 'OKI';
			data.taEvent = this.saveFromProgressBar ? TA_CODES[okiSoki].progressBarNavigation : TA_CODES[okiSoki].nextButtonSave;
			data.claim = { financialData: formData };
			this.postData(data);
		},
		lookupSchools(value) {
			this.getSchools(value);
		},
		onResetSchools() {
			this.resetSchools();
		},
		postTaData() {
			let taEvent = TA_CODES[this.soki ? 'SOKI' : 'OKI'].progressBarNavigation;
			this.postTaFinancial(taEvent);
		},
		...mapActions(['postFinancialForm', 'getSchools', 'resetSchools', 'postTaFinancial'])
	},
	beforeRouteLeave(to, from, next) {
		if (this.$refs.form.isValid() || DEBUG) {
			store.dispatch('addValidPages', from.path);
			let model = this.$refs.form.convertToBackendModel();
			if (!this.postInProgress) {
				this.saveFromProgressBar = true;
				this.saveFinancialData(model);
			}

			next();
		} else if (DEBUG || from.fullPath == store.state.visitedPages[store.state.visitedPages.length - 1]) {
			this.postTaData();
			next();
		} else {
			store.dispatch('removeValidPages', from.path);
			next(false);
			this.$nextTick(() => {
				let elem = document.querySelector('.has-error');
				this.$scrollTo(elem, { duration: 500 });
			});
		}
		this.postInProgress = false;
	},
	beforeRouteEnter(to, from, next) {
		if (from.path == ROUTE_NAMES.SZEMELYES || store.state.visitedPages.indexOf(to.path) != -1 || DEBUG) {
			store.dispatch('setCurrentPage', to.path);
			store.dispatch('addVisitedPages', to.path);
			next();
		} else {
			next(ROUTE_NAMES.SZEMELYES);
		}
	},
	mounted() {
		setTimeout(() => {
			if (this.$route.query.id) {
				let elem = this.$refs.form.$refs[SCROLL_TO_REFS[this.$route.query.id]];
				this.$scrollTo(elem, { duration: 500 });
				elem.focus();
			} else {
				if (!this.isMobile) {
					let elem = document.querySelector('#oki-progress-bar');
					window.scroll(0, elem && offset(elem).top ? offset(elem).top : 0);
				} else {
					window.scroll(0, offset(this.$el).top - HEADER_HEIGHT);
				}
				// eslint-disable-next-line no-warning-comments
				this.$refs.form.$refs['financial-data-title'].focus();
			}
		});
	}
};
